<template>
  <div class="main">
    <div class="main_tabs">
      <el-tabs v-model="activeName">
        <el-tab-pane label="楼号管理" name="first"></el-tab-pane>
        <el-tab-pane label="楼层房号管理" name="second"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="main_content">
      <component :is="activeName === 'first' ? 'BuildingnoIndex' : 'FloornoIndex'"></component>
    </div>
  </div>
</template>

<script>
import BuildingnoIndex from './components/BuildingnoIndex.vue';
import FloornoIndex from './components/FloornoIndex.vue';
  export default {
    components: {
      BuildingnoIndex,
      FloornoIndex
    },
    data() {
      return {
        activeName: 'first'
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '../../../style/layout-main.scss';

/deep/.main {
  background: none;
}
</style>